import BaseService from "services/base";
import { builder } from "utils/graphql";
import { CAMPAIGN_PACKAGE_SELECTION } from "./constant";
import { get } from "utils/lodash";

class Service extends BaseService {
  name = "CampaignPackage";
  static override DEFINITION = builder.createDefinition({
    name: "CampaignPackage",
    baseQuery: "CampaignPackage",
    baseSelection: `
        ${CAMPAIGN_PACKAGE_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
    },
    GQL_ACTIONS: {
      FIND: "CampaignPackages",
      CREATE: "createCampaignPackage",
      UPDATE: "updateCampaignPackage",
      DELETE: "",
    },
    GQL_RESPONSE_DATA_PATH: {
      BASE: "data.CampaignPackage",
      FIND: "data.CampaignPackages.docs",
      PARAMS: "data.CampaignPackages",
    },
  });

  async addFavCampaignPackage(options: any) {
    const nameQuery = "addFavCampaignPackage";
    // const customSelection = selections || SHOP_SELECTION;
    const campaignPackageId = get(options, "campaignPackageId", "");
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
        },

        variables: {
          campaignPackageId,
        },
      },
      `mutation ${nameQuery}($campaignPackageId: String!) {
        ${nameQuery}(campaignPackageId: $campaignPackageId) {
          id
        }
      }`
    );
  }
  async removeFavCampaignPackage(options: any) {
    const nameQuery = "removeFavCampaignPackage";
    const campaignPackageId = get(options, "campaignPackageId", "");
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
        },
        variables: {
          campaignPackageId,
        },
      },
      `mutation ${nameQuery}($campaignPackageId: String!) {
        ${nameQuery}(campaignPackageId: $campaignPackageId) {
          id
        }
      }`
    );
  }
  async getFavCampaignPackages(options: object = {}, selections: string = "") {
    const nameQuery = "myFavCampaignPackages";
    const customSelection = selections || CAMPAIGN_PACKAGE_SELECTION;
    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: "data.myFavCampaignPackages",
          PARAMS: "",
        },
        ...options,
      },
      `query ${nameQuery} {
        ${nameQuery} {
          ${customSelection}
        }
      }`
    );
  }
}
// export * from "./formatter";
const Instance = new Service();

export default Instance;
